module.exports = __webpack_public_path__ + "593a3d53/img/document.e2130c6b.svg";